<template>
  <InputGroup merge>
    <Input
      :placeholder="placeholder"
      v-model="model"
      :type="inputType"
      :hasError="hasError"
    />
    <InputGroupText>
      <i
        @click="handleChangeInputType"
        class="fa-regular cursor-pointer"
        :class="{ 'fa-eye': hidden, 'fa-eye-slash': !hidden }"
      ></i>
    </InputGroupText>
    <slot></slot>
  </InputGroup>
</template>

<script setup lang="ts">
import { ref } from "vue";
import InputGroupText from "./InputGroupText.vue";
import InputGroup from "./InputGroup.vue";

export type InputProps = {
  type?: string;
  hasError?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value?: string;
};

defineProps<InputProps>();

const hidden = ref(true);
const inputType = ref("password");

const emit = defineEmits(["update:modelValue"]);
const model = defineModel<string>();

const handleChangeInputType = () => {
  hidden.value = !hidden.value;
  inputType.value = hidden.value ? "password" : "text";
};
</script>
